/// <amd-module name="SuiteCommerce.GridOrder.PDP"/>
define("SuiteCommerce.GridOrder.PDP", ["require", "exports", "jQuery", "SuiteCommerce.GridOrder.PDP.Configuration", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Item.Controller", "SuiteCommerce.GridOrder", "SuiteCommerce.GridOrder.Item.Model"], function (require, exports, jQuery, PDP_Configuration_1, Utils_1, GridOrder_Item_Controller_1, GridOrder, Item_Model_1) {
    "use strict";
    var UnnecessaryChildViews = [
        'Product.Options',
        'Product.Price',
        'Quantity',
        'AddToProductList',
        'ProductDetails.AddToQuote',
        'MainActionView',
        'Quantity.Pricing',
        'Product.Stock.Info',
    ];
    return {
        pdp: null,
        mountToApp: function (container) {
            if (!PDP_Configuration_1.PDPConfiguration.isGridOrderEnabledForMobile && (Utils_1.Utils.isPhoneDevice() || Utils_1.Utils.isTabletDevice())) {
                return;
            }
            var pdp = container.getComponent('PDP');
            if (pdp) {
                this.pdp = pdp;
                this.cleanPDPLayout();
                GridOrder.mountInVisualComponent(pdp, container);
            }
        },
        cleanPDPLayout: function () {
            var _this = this;
            this.pdp.on('afterShowContent', function () {
                var item = _this.pdp.getItemInfo().item;
                var itemController = new GridOrder_Item_Controller_1.GridOrderItemController({
                    item: new Item_Model_1.ItemModel(item),
                });
                if (itemController.itemIsValidMatrix()) {
                    UnnecessaryChildViews.forEach(function (childViewName) {
                        jQuery(".product-details-full-main-content [data-view=\"" + childViewName + "\"]").remove();
                    });
                }
            });
        },
    };
});
